export default "__VITE_ASSET__DiJ4Zep3__"